import { ConfigProvider } from 'antd';
import RootScreens from 'modules/RootScreens';
import React from 'react';
import { Provider } from 'react-redux';
import store from 'store';
import ModalConfirm, { globalModalConfirmRef } from 'widgets/ModalConfirm';
import NavigateGlobalController, { globalNavigateControllerRef } from 'widgets/Navigate';
import PageLoading, { globalPageLoadingRef } from 'widgets/PageLoading';
import ToastUI, { globalToastUIRef } from 'widgets/Toast';

const AppLayout: React.FC = () => <RootScreens />;

const App: React.FC = () => {

  return (
    <ConfigProvider >
      <Provider store={store}>
        <AppLayout />
        <PageLoading ref={globalPageLoadingRef} />
        <ModalConfirm ref={globalModalConfirmRef} />
        <ToastUI ref={globalToastUIRef} />
        <NavigateGlobalController ref={globalNavigateControllerRef} />
      </Provider>
    </ConfigProvider>
  );
};

export default App;
